import { confirmToast } from "../../utils/toast";
import React, { useState, useEffect } from 'react';
import axios from "../../utils/axiosConfig";

const BuyerBankMaster = () => {
  const emptyForm = { BuyerID: '', BankID: '', AccNo: '', ContactPersonName: '', MobileNumber: '', Remark: '' };
  const [form, setForm] = useState(emptyForm);
  const [buyerList, setBuyerList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [records, setRecords] = useState([]);
  const [editing, setEditing] = useState({ BuyerID: null, BankID: null });
  const [activeTab, setActiveTab] = useState("list");
  const formatBankOption = (bank) => [bank.BankName, bank.Branch].filter(Boolean).join(" - ");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const buyers = await axios.get("/buyers");
    const banks = await axios.get("/banks");
    const mappings = await axios.get("/buyer-banks");
    setBuyerList(buyers.data);
    setBankList(banks.data);
    setRecords(mappings.data);
  };

  const handleChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;
    if (name === "ContactPersonName") value = value.replace(/[^A-Za-z .'-]/g, '');
    if (name === "MobileNumber") value = value.replace(/\D/g, '').slice(0, 10);
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.ContactPersonName && !/^[A-Za-z .'-]+$/.test(form.ContactPersonName.trim())) {
      alert("Contact person name can contain letters, spaces, apostrophes, hyphens and periods only");
      return;
    }
    if (form.MobileNumber && !/^\d{10}$/.test(form.MobileNumber)) {
      alert("Mobile number must contain exactly 10 digits");
      return;
    }

    try {
      if (editing.BuyerID && editing.BankID) {
        await axios.put(`${"/buyer-banks"}/${editing.BuyerID}/${editing.BankID}`, form);
      } else {
        await axios.post("/buyer-banks", form);
      }
      alert(editing.BuyerID && editing.BankID ? "Buyer bank updated successfully" : "Buyer bank saved successfully");
      await fetchData();
      resetForm();
      setActiveTab("list");
    } catch (err) {
      alert("Error saving: " + (err.response?.data || err.message));
    }
  };

  const handleRowClick = (row) => {
    setForm({
      BuyerID: row.BuyerID,
      BankID: row.BankID,
      AccNo: row.AccNo,
      ContactPersonName: row.ContactPersonName || '',
      MobileNumber: row.MobileNumber || '',
      Remark: row.Remark || ''
    });
    setEditing({ BuyerID: row.BuyerID, BankID: row.BankID });
  };

  const handleDelete = async (BuyerID, BankID) => {
    if (await confirmToast("Delete this mapping?")) {
      await axios.delete(`${"/buyer-banks"}/${BuyerID}/${BankID}`);
      fetchData();
    }
  };

  const resetForm = () => {
    setForm(emptyForm);
    setEditing({ BuyerID: null, BankID: null });
  };

 return (
  <div className="container mt-3">

    {/* ===== PAGE TITLE ===== */}
    <div className="mb-3">
      
      <h4 className="fw-bold mb-0">🏦 Buyer Bank Master</h4>
      <small className="text-muted">
        Map Buyers with Banks and Account Numbers
      </small>
    </div>

    <div className="card shadow-sm border-0">

      {/* ===== TABS ===== */}
      <div className="card-header bg-white">
        <ul className="nav nav-tabs card-header-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "list" ? "active" : ""}`}
              onClick={() => setActiveTab("list")}
            >
              Mapping List
            </button>
          </li>

          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "form" ? "active" : ""}`}
              onClick={() => setActiveTab("form")}
            >
              {editing.BuyerID ? "Edit Mapping" : "Add Mapping"}
            </button>
          </li>
        </ul>
      </div>

      {/* ===== BODY ===== */}
      <div className="card-body">

        {/* ================= LIST TAB ================= */}
        {activeTab === "list" && (
          <>
            <div className="d-flex justify-content-between mb-3">
              <h5>Buyer Bank Mapping List</h5>
              {/* <button
                className="btn btn-primary"
                onClick={() => {
                  resetForm();
                  setActiveTab("form");
                }}
              >
                + Add Mapping
              </button> */}
            </div>

            <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Buyer</th>
                  <th>Bank</th>
                  <th>Account No</th>
                  <th>Contact Person</th>
                  <th>Mobile Number</th>
                  <th>Remark</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {records.map(row => (
                  <tr key={`${row.BuyerID}_${row.BankID}`}>
                    <td className={!row.BuyerExists ? "text-danger" : ""}>{row.BuyerName}</td>
                    <td className={!row.BankExists ? "text-danger" : ""}>{formatBankOption(row)}</td>
                    <td>{row.AccNo}</td>
                    <td>{row.ContactPersonName || "-"}</td>
                    <td>{row.MobileNumber || "-"}</td>
                    <td>{row.Remark || "-"}</td>
                    <td className="text-center">

                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => {
                          handleRowClick(row);
                          setActiveTab("form");
                        }}
                      >
                        Edit
                      </button>

                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(row.BuyerID, row.BankID)}
                      >
                        Delete
                      </button>

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </>
        )}

        {/* ================= FORM TAB ================= */}
        {activeTab === "form" && (
          <form onSubmit={handleSubmit}>
            <div className="row g-3">

              {/* Buyer */}
              <div className="col-md-3">
                <label className="form-label fw-semibold">Buyer</label>
                <select
                  name="BuyerID"
                  value={form.BuyerID}
                  onChange={handleChange}
                  className="form-select"
                  required
                >
                  <option value="">Select Buyer</option>
                  {buyerList.map(b => (
                    <option key={b.BuyerID} value={b.BuyerID}>
                      {b.BuyerName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Bank */}
              <div className="col-md-3">
                <label className="form-label fw-semibold">Bank</label>
                <select
                  name="BankID"
                  value={form.BankID}
                  onChange={handleChange}
                  className="form-select"
                  required
                >
                  <option value="">Select Bank</option>
                  {bankList.map(b => (
                    <option key={b.BankID} value={b.BankID}>
                      {formatBankOption(b)}
                    </option>
                  ))}
                </select>
              </div>

              {/* Account Number */}
              <div className="col-md-3">
                <label className="form-label fw-semibold">Account Number</label>
                <input
                  type="text"
                  name="AccNo"
                  value={form.AccNo}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              {/* Contact Person */}
              <div className="col-md-3">
                <label className="form-label fw-semibold">Contact Person Name</label>
                <input
                  type="text"
                  name="ContactPersonName"
                  value={form.ContactPersonName}
                  onChange={handleChange}
                  className="form-control"
                  maxLength={150}
                  pattern="[A-Za-z .'-]+"
                  title="Use letters, spaces, apostrophes, hyphens and periods only"
                />
              </div>

              <div className="col-md-3">
                <label className="form-label fw-semibold">Mobile Number</label>
                <input
                  type="tel"
                  name="MobileNumber"
                  value={form.MobileNumber}
                  onChange={handleChange}
                  className="form-control"
                  inputMode="numeric"
                  autoComplete="tel"
                  maxLength={10}
                  pattern="[0-9]{10}"
                  title="Enter exactly 10 digits"
                />
                <small className="text-muted">Enter a 10-digit mobile number</small>
              </div>

              {/* Remark */}
              <div className="col-md-3">
                <label className="form-label fw-semibold">Remark</label>
                <input
                  type="text"
                  name="Remark"
                  value={form.Remark}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

            </div>

            {/* Buttons */}
            <div className="mt-4 text-end">
              <button type="submit" className="btn btn-success me-2">
                {editing.BuyerID ? "Update" : "Save"}
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setActiveTab("list")}
              >
                Back to List
              </button>
            </div>
          </form>
        )}

      </div>
    </div>
  </div>
);

};

export default BuyerBankMaster;
